import React from 'react';
// Images
import mainBannerImg from '../image/main_banner_kit.png';
// Components
import PageContainer from '../components/PageContainer';
// import KitTopBar from '../components/kit/KitTopBar';
import KitTerms from '../components/kit/KitTerms';

const KitTermsPage = () => {
    return (
        <PageContainer
            mainBannerSrc={mainBannerImg}
            // topBar={<KitTopBar />}
        >
            <KitTerms />
        </PageContainer>
    );
};

export default KitTermsPage;
